import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  LinearProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { getTrainingUnlockLogs } from "../../../store/structure/actions";

const actionBadge = {
  UNLOCK: "badge-success",
  EXTEND: "badge-info",
  LOCK: "badge-secondary",
};

const actionBorder = {
  UNLOCK: "border-success",
  EXTEND: "border-info",
  LOCK: "border-secondary",
};

const actionLabel = {
  UNLOCK: "Unlocked",
  EXTEND: "Extended",
  LOCK: "Removed unlock",
};

const TrainingUnlockLogsDialog = (props) => {
  const { open, employee, onClose, getTrainingUnlockLogs } = props;

  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open && employee?.id) {
      getTrainingUnlockLogs(employee.id, setLogs, setIsLoading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, employee?.id]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle className="text-primary">
        Training dates unlock history
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {employee && (
          <p className="mb-2">
            <strong>
              {employee.lastName} {employee.firstName}
            </strong>
          </p>
        )}

        {isLoading && <LinearProgress />}

        {!isLoading &&
          logs.map((log) => (
            <div
              key={log.id}
              className={`card mb-2 ${
                actionBorder[log.action] || "border-secondary"
              }`}
            >
              <div className="card-header py-2 d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <span
                    className={`badge ${
                      actionBadge[log.action] || "badge-secondary"
                    } mr-2`}
                  >
                    {actionLabel[log.action] || log.action}
                  </span>
                  {!!log.daysAdded && (
                    <small className="text-muted">
                      {log.daysAdded} day{log.daysAdded > 1 ? "s" : ""}
                    </small>
                  )}
                </div>
                <small className="text-muted">
                  {moment(log.createdOn).format("lll")}
                </small>
              </div>
              <div className="card-body py-2">
                <div className="mb-2">
                  <small className="text-muted d-block">By</small>
                  {log.lastName} {log.firstName}
                </div>
                <div>
                  <small className="text-muted d-block">Reason</small>
                  <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    {log.reason || "-"}
                  </div>
                </div>
              </div>
            </div>
          ))}

        {!isLoading && !logs.length && (
          <p className="text-muted text-center mb-0">No history found</p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default connect(null, { getTrainingUnlockLogs })(
  TrainingUnlockLogsDialog
);
